export const updateObject = (oldObject, updatedValues) => {
    return {
        ...oldObject,
        ...updatedValues
    }
};


// WEBPACK FOOTER //
// ./src/store/utility.js